/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberAppointmentsIdQueryResponse, GetApiBarberAppointmentsIdPathParams, GetApiBarberAppointmentsId400, GetApiBarberAppointmentsId401, GetApiBarberAppointmentsId403, GetApiBarberAppointmentsId404, GetApiBarberAppointmentsId500 } from "../entities/GetApiBarberAppointmentsId";

function getGetApiBarberAppointmentsIdUrl(id: GetApiBarberAppointmentsIdPathParams["id"]) {
  const res = { method: 'GET', url: `/api/barber/appointments/${id}` as const }
  return res
}

/**
 * @description Получить детали записи для мастера
 * @summary Получить запись
 * {@link /api/barber/appointments/:id}
 */
export async function getApiBarberAppointmentsId(id: GetApiBarberAppointmentsIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBarberAppointmentsIdQueryResponse, ResponseErrorConfig<GetApiBarberAppointmentsId400 | GetApiBarberAppointmentsId401 | GetApiBarberAppointmentsId403 | GetApiBarberAppointmentsId404 | GetApiBarberAppointmentsId500>, unknown>({ method : "GET", url : getGetApiBarberAppointmentsIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}